import React from 'react'
import { Carousel } from 'nuka-carousel'
import Leaderboard from 'components/Common/Banner/Leaderboard'
import { EmptyArray } from 'lib/array/arrayUtils'
import styled from 'styled-components'

const BannerLeaderboard = styled(Leaderboard)`
  min-width: 100%;
`

interface Props {
  banners: Array<App.ListBanner>
  onBannerClick?: (banner: App.ListBanner) => void
  onBannerLoad?: (banner: App.ListBanner) => void
  interval?: number
  onClickOpenNewTab?: boolean
}

function BannerCarousel({
  banners = EmptyArray,
  onBannerClick,
  onBannerLoad,
  interval = 5,
  onClickOpenNewTab,
}: Props) {
  if (banners.length > 1) {
    return <Carousel
      autoplay
      autoplayInterval={interval * 1000}
      showArrows={false}
      showDots={false}
      wrapMode="wrap"
    >
      {banners.map(banner => <BannerLeaderboard
        key={banner.bannerId}
        banners={[banner]}
        onBannerClick={onBannerClick}
        onBannerLoad={onBannerLoad}
        onClickOpenNewTab={onClickOpenNewTab}
      />)}
    </Carousel>
  }

  if (banners.length === 1) {
    return <Leaderboard
      banners={banners}
      onBannerClick={onBannerClick}
      onClickOpenNewTab={onClickOpenNewTab}
    />
  }

  return null
}

export default BannerCarousel
